interface Props {
  adminEmail: string;
  targetEmail: string;
  onStop: () => void;
  busy: boolean;
}

/** A persistent, hard-to-miss strip while an admin "view as" session is active — impersonation is full-access, so it should never be silent about whose account is currently being acted as. */
export function ImpersonationBanner({ adminEmail, targetEmail, onStop, busy }: Props) {
  return (
    <div className="impersonation-banner">
      <span>
        Viewing as <strong>{targetEmail}</strong> — signed in as admin <strong>{adminEmail}</strong>
      </span>
      <button className="btn sm" onClick={onStop} disabled={busy}>
        {busy ? <span className="spin" /> : null}
        Exit
      </button>
    </div>
  );
}
